













import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentImage: () => import('~/components/images/image.vue'),
  },
})
export default class ComponentLogo extends Vue {
  @siteStore.State('logo') private logo!: {
    mobile: {
      image: IImageVariants | null
      aspectRatio: string | number | Array<string | number>
    }
    desktop: {
      image: IImageVariants | null
      aspectRatio: string | number | Array<string | number>
    }
  } | null

  @siteStore.State('brand') private brand!: string
  @siteStore.State('origin') private origin!: string

  private get structuredData() {
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: this.origin,
      logo: this.imageLogo,
    }
  }

  private get logoCurrent() {
    if (this.logo) {
      return this.$device.isMobileOrTablet
        ? this.logo.mobile
        : this.logo.desktop
    }
    return null
  }

  private get logoAspectRatio(): string | number {
    if (!this.logoCurrent) return ''
    const { aspectRatio } = this.logoCurrent
    if (Array.isArray(aspectRatio)) {
      if (aspectRatio.length >= 2) {
        return `${aspectRatio[0]} / ${aspectRatio[1]}`
      }
      return aspectRatio.length ? String(aspectRatio[0]) : ''
    }
    return aspectRatio
  }

  private get imageLogo() {
    if (!this.logoCurrent) return null
    if (typeof this.logoCurrent.image === 'string') {
      return this.logoCurrent.image
    }
    if (
      this.logoCurrent.image &&
      Object.keys(this.logoCurrent.image).length > 0
    ) {
      const accum: string[] = []
      Object.entries(this.logoCurrent.image).forEach((currentImage) => {
        accum.push(currentImage[1])
      })
      return accum[accum.length - 1]
    }
    return null
  }

  private head() {
    return {
      script: [
        {
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }
}
